import { useState } from 'react'
import ViewTallIcon from '@mui/icons-material/ViewDay'
import ViewCompactIcon from '@mui/icons-material/ViewHeadline'
import ViewMediumIcon from '@mui/icons-material/ViewStream'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { ROW_MODE_COMPACT, ROW_MODE_MEDIUM, ROW_MODE_TALL } from '../../ReadGridConstants'

const ICON_BY_ROW_MODE = {
  [ROW_MODE_COMPACT]: ViewCompactIcon,
  [ROW_MODE_MEDIUM]: ViewMediumIcon,
  [ROW_MODE_TALL]: ViewTallIcon,
}

export const RowModeSelector = ({ rowMode, onRowModeChange }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuItemClick = mode => {
    onRowModeChange(mode)
    handleClose()
  }

  const open = Boolean(anchorEl)
  const id = open ? 'row-mode-popover' : undefined
  const minWidthOverride = { minWidth: 32 }
  const Icon = ICON_BY_ROW_MODE[rowMode] || ICON_BY_ROW_MODE[ROW_MODE_COMPACT]

  return (
    <>
      <IconButton
        aria-label="Change row height"
        size="medium"
        onClick={handleClick}
        style={{ padding: 5 }}
        data-testid="icon-button"
      >
        <Icon data-testid="mode-icon" />
      </IconButton>
      <Menu
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        data-testid="mode-selector-menu"
      >
        <MenuItem
          onClick={() => {
            handleMenuItemClick(ROW_MODE_COMPACT)
          }}
          data-testid="mode-selector-menu-item"
          dense
        >
          <ListItemIcon style={minWidthOverride} data-testid="list-item-icon">
            <ViewCompactIcon fontSize="small" data-testid="view-compact-icon-small" />
          </ListItemIcon>
          <ListItemText primary="Compact" data-testid="list-item-text-compact" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuItemClick(ROW_MODE_MEDIUM)
          }}
          data-testid="mode-selector-menu-item"
          dense
        >
          <ListItemIcon style={minWidthOverride} data-testid="list-item-icon">
            <ViewMediumIcon fontSize="small" data-testid="view-medium-icon-small" />
          </ListItemIcon>
          <ListItemText primary="Medium" data-testid="list-item-text-medium" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleMenuItemClick(ROW_MODE_TALL)
          }}
          data-testid="mode-selector-menu-item"
          dense
        >
          <ListItemIcon style={minWidthOverride} data-testid="list-item-icon">
            <ViewTallIcon fontSize="small" data-testid="view-tall-icon-small" />
          </ListItemIcon>
          <ListItemText primary="Large" data-testid="list-item-text-large" />
        </MenuItem>
      </Menu>
    </>
  )
}
